import React, { useEffect, useRef } from "react";
import type { LessonChapterScrollContainerProps } from "./LessonChapterScrollContainer";

export default function LessonChapterScrollContainer({
  height,
  children,
  scrollActiveChapterIndex = null,
  chapterRowHeightEstimate = 74,
  scrollLayoutKey = 0,
}: LessonChapterScrollContainerProps) {
  const divRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (scrollActiveChapterIndex == null || scrollActiveChapterIndex < 0) return;
    const row = chapterRowHeightEstimate;
    const itemTop = scrollActiveChapterIndex * row;
    const itemCenter = itemTop + row / 2;

    const run = () => {
      const el = divRef.current;
      if (!el) return;
      const viewH = el.clientHeight;
      const maxY = Math.max(0, el.scrollHeight - viewH);
      let scrollY = Math.max(0, itemCenter - viewH / 2);
      scrollY = Math.min(scrollY, maxY);
      el.scrollTo({ top: scrollY, behavior: "smooth" });
    };

    const raf = requestAnimationFrame(() => requestAnimationFrame(run));
    const t1 = setTimeout(run, 48);
    const t2 = setTimeout(run, 160);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [scrollActiveChapterIndex, height, chapterRowHeightEstimate, scrollLayoutKey]);

  return (
    <div
      ref={divRef}
      style={{
        height,
        overflowY: "auto",
        overscrollBehavior: "contain",
        touchAction: "pan-y",
        WebkitOverflowScrolling: "touch",
      }}
    >
      {children}
    </div>
  );
}
